module.exports = __webpack_public_path__ + "img/geofisica_9-16_1080.b57a79eb.webp";